export function getErrorMessage(error: unknown, fallback: string): string {
  return error instanceof Error ? error.message : fallback;
}

export function redirectToDashboard(): void {
  window.location.href = "/dashboard";
}

export function redirectToLogin(): void {
  window.location.href = "/login";
}
